// Libs
import React from 'react'
import { Row, Col } from '../../../../components/Elemental'
import _ from 'lodash'

// CSS
import './styles.scss'

// Components/Containers
import SideBar from '../../../../components/SideBar'
import GaugeChart from '../../../../components/GaugeChart'
import Drive from '../../../Drive'
import SpCasePageMoreInfosComments from '../SpCasePageMoreInfosComments'
import SpCasePageMoreInfosSection from '../SpCasePageMoreInfosSection'
import SpCasePageMoreInfosTags from '../SpCasePageMoreInfosTags'

// Constants
import { capitalize, currency, toDateFormat, deadlineDate } from '../../../../constants/normalize'
import { getStatusName, formatDate, formatReal, getLawsuitSegment, getlinkToTJ } from '../../../../constants/others'

const SpCasePageMoreInfos = ({
  visible,
  user: { admin, lawFirmId, manager, role },
  spCase: {
    id,
    createdReal,
    lawsuitNumber,
    lawsuitUf,
    client,
    lawyer,
    company,
    lawFirm,
    chat,
    origin,
    timeLeft,
    status,
    maxValue,
    provision,
    obligation,
    ps,
    comment,
    classifiers,
    group,
    deadline,
    probability,
    externalInfo
  },
  handleOpen,
  handleClose,
  handleChange,
  handleSave,
  handleCommentChange,
  handleCommentBlur }) => {
  const link = getlinkToTJ(lawsuitNumber, lawsuitUf)

  return (
    <SideBar
      visible={visible}
      title="Mais Informações"
      button="Mais Informações"
      role={role}
      handleOpen={handleOpen}
      handleClose={handleClose}>
      {(probability && status === 2) ?
        <div className="sp-case-page-infos__gauge">
          <div className="sp-case-page-infos__gauge__title">
            <span>Probabilidade de Acordo</span>
            <a href="https://spectter.com.br/" target="_blank">By Spectter</a>
          </div>
          <GaugeChart value={probability} maxValue={100} type={0} />
        </div> : ""}
      <SpCasePageMoreInfosSection
        title="Informações Gerais"
        link={link}
        options={[
          { name: 'Nº Caso', value: id },
          { name: 'Status', value: !_.isEmpty(chat) ? getStatusName(chat[chat.length - 1]['status']) : '' },
          { name: 'Nº Proc', value: lawsuitNumber, link },
          { name: 'Segmento', value: lawsuitNumber ? getLawsuitSegment(lawsuitNumber).segment : '' },
          { name: 'Parte', value: client ? client.fullName ? capitalize(client.fullName) : '' : '' },
          { name: 'Empresa', value: company ? (company.fantasyName ? company.fantasyName : company.name) : '' },
          { name: 'Escritório', value: lawFirm ? lawFirm.name : '' },
          { name: 'Criado Em', value: createdReal ? formatDate(createdReal) : '' },
          { name: 'Módulo', value: origin ? origin === 1 ? 'Pre Contencioso' : 'Contencioso' : '' },
        ]}
      />
      {role === 'company' &&
        <SpCasePageMoreInfosSection
          title="Informações do Advogado"
          options={[
            { name: 'Nome', value: lawyer && lawyer.name ? `${lawyer.name} ${lawyer.surname}` : '' },
            { name: 'OAB', value: lawyer && lawyer.oabNumber ? `${lawyer.oabNumber}/${lawyer.oabUf}` : '' }
          ]}
        />
      }
      {role === 'company' &&
        <SpCasePageMoreInfosSection
          editable={((manager || admin) && !lawFirmId) ? true : false}
          title="Informações Adicionais"
          handleChange={handleChange}
          handleSave={handleSave}
          options={[
            { name: 'Alçada(R$)', value: maxValue ? formatReal(maxValue, false) : '', editable: ((manager || admin) && !lawFirmId) ? true : false, field: 'maxValue', normalize: currency },
            { name: 'Provisão(R$)', value: provision ? (!lawFirmId ? formatReal(provision, false) : '') : '', editable: ((manager || admin) && !lawFirmId) ? true : false, field: 'provision', normalize: currency },
            { name: 'Código do Sistema', value: ps ? ps : '', editable: ((manager || admin) && !lawFirmId) ? true : false, field: 'ps' },
            { name: 'Outras Obrigações', value: obligation ? obligation : '', wrap: true },
            { name: 'Prazo', value: deadline ? deadlineDate(new Date(deadline)) : '', editable: ((manager || admin) && !lawFirmId) ? true : false, field: 'deadline', calendar: true }
          ]}
        />
      }
      {role === 'company' && externalInfo && externalInfo.length > 0 &&
        <SpCasePageMoreInfosSection
          title="Informações Externas"
          betaTag={true}
          options={externalInfo}
        />
      }
      {group.drive ? <Drive /> : ''}
      {!_.isEmpty(classifiers) && role === 'company' &&
        <SpCasePageMoreInfosTags
          title="Classificações"
          options={classifiers}
        />
      }
      {role === 'company' &&
        <SpCasePageMoreInfosComments
          title="Comentários"
          value={comment}
          handleChange={handleCommentChange}
          handleBlur={handleCommentBlur}
        />
      }
    </SideBar>
  )
}

export default SpCasePageMoreInfos
